import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PptxSvg = function PptxSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5c0 .137.112.25.25.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.147 6.5 17 2.354V6.25c0 .138.113.25.25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M21.78 6.427 17.073 1.72a.76.76 0 0 0-.53-.22H6.75a.75.75 0 0 0-.75.75v19.5c0 .413.337.75.75.75h14.5a.75.75 0 0 0 .75-.75V6.957c0-.2-.078-.388-.22-.53M17 2.354 21.147 6.5H17.25a.25.25 0 0 1-.25-.25zM6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    d: "M16.5 12.5 16 12h-1.5l-.5.5v2.592a3.25 3.25 0 0 0 5.5-2.342v-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F6B",
    d: "M16.25 9.5a3.23 3.23 0 0 0-2.25.91v2.09h2.5v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7B5",
    d: "M17.5 8.5v3h3a3 3 0 0 0-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C43E1C",
    d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    fillRule: "evenodd",
    d: "M9.442 10.481Q8.884 10 7.834 10H5.5v6h1.145v-2.121H7.76q.67 0 1.18-.253.507-.254.785-.71.275-.456.275-1.042 0-.911-.558-1.393M7.63 12.963h-.985v-2.034h1.022q1.127 0 1.127.992 0 .51-.294.776t-.87.266",
    clipRule: "evenodd"
  }));
};
export var Pptx = function Pptx(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PptxSvg
  }));
};